<template>
  <a-layout class='s_bf'>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="卡券" name="" help='可选择1~5张优惠券'>
        <div class="width100 s_flex_bian_c m-t-5"> 
          <div class="storeBox width80">
            <div class="s_flex_wrap p-t-5" v-if='couponList.length' style="display: flex;align-content: space-between;">
              <a-tag class='m-b-5'  v-for='(item,index) in couponList' :key='item' closable @close.prevent="couponDel(index)" >{{item.name}}</a-tag>
            </div>
            <p class="s_c999" style="padding: 4px 0;" v-else>请选择优惠券</p>
          </div>
          <a-button type="primary" @click="showCoupon = true">选择</a-button>
        </div>
      </a-form-item>
      <a-form-item label="备注" name="remarks">
        <a-textarea v-model:value="form.remarks" placeholder="如：备注发放优惠券的原因，方便稽查" :rows="4" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
        <a-button type="primary" @click="onSubmit">确定</a-button>
      </a-form-item>
    </a-form>
    <a-modal  :keyboard="false" title="选择优惠券" centered v-model:visible="showCoupon" :footer='null' :width='1300' destroyOnClose>
      <selectCoupon v-on:select="couponSelect" :selectList='couponList' :checkout="true" :selectLimit='5'></selectCoupon>
    </a-modal>
  </a-layout>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import { memberAddCoupon } from '@/api/member'
  // 初始化默认筛选项数值
  let defForm = {
    member_id:'',
    coupon_ids:[],
    remarks:'',
  }
  export default {
    name: 'addCoupon',
    components: {},
    props: {
      id: {
        type: Object
      },
    },
    setup(props, { emit }) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        id:{},
        couponList:[],
        showCoupon:false
      });
      const ruleForm = ref()
      const _lodash = inject("_lodash");
      //选择优惠券
      const couponSelect = (e) => {
        state.couponList = e
        state.showCoupon = false
      }
      //删除优惠券
      const couponDel = (e) =>{
        state.couponList.splice(e,1)
      }
      //提交
      const onSubmit = async() => {
        const coupon_ids = _lodash.map(state.couponList, 'id')
        let res = await memberAddCoupon({...form.value,coupon_ids:JSON.stringify(coupon_ids)}).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          message.success(res.msg);
          emit('onsubmit')
        }else{
          message.error(res.msg);
        }
      }
      onMounted(() => {
        form.value.member_id = props.id
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        couponSelect,
        couponDel
      }
    }
  }
</script>
<style lang="less" scoped>
  .storeBox{
    box-sizing: border-box;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: all 0.3s;
    padding: 0 11px;
    line-height: 1.5715;
  }
  </style>